import { Injectable } from "@angular/core";
import { DwAction, DwActionHandler, DwActionResult, DwActionType, DwButtonType, DwMdFormActionState, DwRoutingService } from "@devwareapps/devware-cap";
import { Observable, of } from "rxjs";
import { AppMetaDataItemNames, CheckRideRequestEntity } from "../../../../meta-data/app-meta-data.service";
import { mergeMap } from "rxjs/operators";




@DwAction({
    keyName: 'rebook-school-checkride',
    display: 'Rebook School Checkride',
    parentItemName: [AppMetaDataItemNames.CheckRideRequest, AppMetaDataItemNames.CheckRideResult],
    isGlobal: false,
    actionType: DwActionType.formAction,
    defaultButtonConfig: {
        useParentDisplay: false,
        buttonText: 'Rebook Checkride',
        buttonClass: 'btn btn-warning btn-sm',
        buttonTitle: 'Rebook Checkride',
        buttonType: DwButtonType.standard,
        iconClass: 'fa fa-plane-departure'
    }
})
@Injectable()
export class RebookSchoolCheckrideActionService  implements DwActionHandler  {

    constructor(private dwRoutingService: DwRoutingService) {}

    handleAction(actionState: DwMdFormActionState): Observable<DwActionResult> {
        const result = new DwActionResult();
       
        const checkride = actionState.formApi.getFormData<CheckRideRequestEntity>();

        // Save the checkride first, then navigate to the rebook page
        return actionState.formApi.saveData(true)
        .pipe(mergeMap(saveResult => {

            if (saveResult.cancelled || saveResult.validationFailed) {
                result.cancelled = true;
                return of(result);
            }

            const url = '/school-checkrides/add?RebookCheckrideId=' + checkride.CheckRideRequestId;
    
            this.dwRoutingService.navigateToUrl(url, { });
    
            result.success = true;
            return of(result);
        }));
    }
}